exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content_container {\n    margin-top: 55px;\n}\n.nav_container {\n    padding-left: 0px !important;\n}\nli.is-active {\n    background-color: #999;\n}\nli.is-active a, li.is-active a:active, li.is-active a:visited, li.is-active a:hover{\n    color: #fff !important;\n}\n\n.image_size {\n  width: 15%;\n  height: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/styles.css
// module id = 890
// module chunks = 1